module.exports = __webpack_public_path__ + "static/media/03_nevada_top_path_draw.0241f4b2.gif";